import { Zap, Lightbulb, ScanLine, BookOpen } from "lucide-react";

export const PosterScanLine = () => (
  <p data-testid="poster-scan-line" className="flex items-start justify-center gap-2 font-body text-xs sm:text-base print:text-sm leading-snug mt-[3%] text-center max-w-[90%]"><ScanLine size={18} className="text-[#9E4735] flex-shrink-0 mt-0.5" /> <span>Scannez le QR Code avec l'appareil photo de votre téléphone pour <strong>2 à 5 min de lecture instantanée</strong> sur votre écran – moins de 1 Mo consommé</span></p>
);

export const PosterNetworkInfo = () => (
  <div data-testid="poster-network-info" className="border border-[#2C402E]/40 bg-[#F4F1EA] px-4 py-2.5 text-left font-body text-[11px] sm:text-sm print:text-xs leading-snug space-y-1.5">
    <p className="flex gap-2"><Zap size={15} className="text-[#9E4735] flex-shrink-0 mt-0.5" /><span><strong>Info réseau : ultra-léger en internet (&lt; 1 Mo).</strong> Cet extrait consomme moins de 1 Mo (moins qu'une photo WhatsApp). Zéro application requise.</span></p>
    <p className="flex gap-2"><Lightbulb size={15} className="text-[#9E4735] flex-shrink-0 mt-0.5" /><span><strong>Astuce :</strong> dès que la page s'ouvre, vous pouvez même couper vos données mobiles pour lire hors-ligne !</span></p>
  </div>
);

export const PosterDidYouKnow = () => (
  <div data-testid="poster-did-you-know" className="font-body text-sm sm:text-base print:text-sm text-[#4A4A4A] leading-relaxed print:leading-snug max-w-[85%] mx-auto">
    <p className="font-semibold text-[#2C402E] mb-1">Le saviez-vous ?</p>
    <p>La lecture réduit le stress et stimule l'imagination.</p>
    <p>Profitez de ce moment</p>
    <p>pour découvrir le talent de nos auteurs.</p>
  </div>
);

export const PosterHeadline = ({ count = 1 }) => (
  <>
    <p data-testid="poster-headline" className="flex items-center justify-center gap-3 font-body font-bold uppercase tracking-[0.04em] text-[#9E4735] text-2xl sm:text-[2.6rem] leading-[1.1] mb-[3%]">
      <BookOpen size={36} className="flex-shrink-0" />
      <span>{count > 1 ? `${count} histoires offertes` : "Histoire offerte"} à lire sur votre téléphone !</span>
    </p>
    <p data-testid="poster-subheadline" className="font-serif text-base sm:text-xl font-light leading-snug mb-[4%]">Offrez-vous une pause pour <em className="text-[#2C402E]">nourrir votre esprit</em></p>
  </>
);
